import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';

export const InputVerifiedBadge = () => (
	<div>
		<FaCheckCircle className="text-success mr-1" />
		Verified
	</div>
);
